let idCounter = 0

export const idGenerator = () => `new-${new Date().getTime() + idCounter++}`

export const isNewRecord = id => String(id).startsWith('new-')
